module.exports = __webpack_public_path__ + "img/健康和安全类.89016135.png";